<template>
    <div ref="inter" class="interlinking-pages">
        <div class="interlinking-pages__links">
            <p class="p1 interlinking-pages__title" v-html="title"></p>
            <slot />
        </div>
        <a v-if="btnVisible" @click="openLinks"
           class="button button_size-sm button_show _mt-16-8">Показать все</a>
    </div>
</template>
<script>
export default {
    name: 'InterlinkingPages',
    props: ['title'],
    data() {
        return {
            btnVisible: false,
        }
    },
    methods: {
        hideLinks() {
            const links = [...this.$refs.inter.querySelectorAll('.interlinking-pages a')];
            links.map((link, ind) => {
                if (ind > 15) {
                    link.classList.add('_hidden');
                    if (!this.btnVisible) this.btnVisible = true;
                }
            });
        },
        openLinks() {
            const links = [...this.$refs.inter.querySelectorAll('.interlinking-pages ._hidden')];
            links.map(link => link.classList.remove('_hidden'));
            this.btnVisible = false;
        }
    },
    mounted() {
        this.hideLinks();
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/base/_variables.scss';
@import '../../assets/scss/base/_mixins.scss';
@import '../../assets/scss/base/_functions.scss';

$b: '.interlinking-pages';

#{$b} {

    &__links {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 2rem;
        grid-row-gap: 0.6666rem;

        @include mobile {
            display: flex;
            flex-wrap: wrap;
            grid-column-gap: 1rem;
        }
    }

    &__title {
        grid-column: 1 / -1;
        font-weight: bolder;

        @include mobile {
            width: 100%;
        }
    }

}
</style>
